import { apiConstants } from '../../apiConstant'
import { serviceCall, serviceCallAuth } from '../../serviceCall'

export const userNotificationCount = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.NOTIFICATION.USER_NOTIFICATION,
      method: 'post',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
